import awsIot from 'aws-iot-device-sdk';

export default class WebsocketClient {
  constructor(eventBus, store, logger, host, region) {
    this.initialized = false;
    this.device = null;
    this.logger = logger;
    this.host = host;
    this.region = region;

    this.eventBus = eventBus;
    this.store = store;
    this.isLocal = host.includes('localhost');

    /* TODO: Remove this disable bit and add websocket support for the tests */
    if (this.isLocal) {
      return;
    }

    this.store.watch(state => state.member.accessTokens, () => {
      if (this.store.getters.isAuthenticated()) {
        return this.initialize();
      }
      return this.reset();
    });

    if (this.store.getters.isAuthenticated() && !this.store.getters.tokensExpired()) {
      this.initialize().catch(console.error);
    }
  }

  reset() {
    if (this.device) {
      if (this.isLocal) {
        this.device.close();
      } else {
        this.device.end();
      }
    }
    this.device = null;
    this.initialized = false;
    this.logger.log('Websocket disconnected');
  }

  async initialize() {
    if (this.initialized) {
      return;
    }

    let clientId;
    const tokens = this.store.getters.tokens;
    if (tokens.tokenType === 'Anonymous') {
      clientId = tokens.identityId.split(':').pop();
    } else {
      clientId = this.store.getters.cognitoId;
    }

    if (!tokens || !clientId || !this.store.getters.isAuthenticated()) {
      return;
    }

    if (this.isLocal) {
      this.connectWebsocket();
    } else {
      try {
        this.device = awsIot.device({
          region: this.region,
          host: this.host,
          clientId,
          protocol: 'wss',
          accessKeyId: tokens.accessKeyId,
          secretKey: tokens.secretKey,
          sessionToken: tokens.sessionToken,
        });
      } catch (e) {
        setTimeout(() => this.initialize(), 1000);
        console.error(e);
      }
      this.connect(clientId);
    }

    this.initialized = true;
  }

  connectWebsocket() {
    this.device = new WebSocket(`ws://${this.host}`);
    this.device.addEventListener('message', (e) => {
      this._handleMessage(e.data);
    });
    this.device.addEventListener('close', () => {
      this.logger.log('Reconnecting');
      this.connectWebsocket();
    });
    this.device.addEventListener('error', console.error);
    this.logger.log('Websocket connected');
  }

  connect(cognitoId) {
    try {
      this.device.on('error', (error) => {
        console.log(error);
      });

      this.device.on('connect', () => {
        this.logger.log('Websocket connected');
        this.device.subscribe(`web/${cognitoId}`);
      });

      this.device.on('message', (topic, payload) => {
        this._handleMessage(payload);
      });
    } catch (e) {
      console.error(e);
    }
  }

  _handleMessage(payload) {
    const p = JSON.parse(payload.toString());
    // this.logger.log('Incoming IoT message', p);
    if (p.message['_headers']) {  // eslint-disable-line
      this.eventBus.emit(p.message['_headers']['event_name'], p.message); // eslint-disable-line
    } else {
      this.logger.capture(`Don't know how to handle payload: ${payload.toString()}`);
    }
  }
}
